import React from 'react';
import './mobileStyles.scss';

const ImmotechMobile = () => {
  return (
    <section className="immotech-mobile-section">
      <div className="immotech-mobile-background">
        <img src="/2025/immotech/images/immotechBackgroundMobile.svg" alt="" />
      </div>
      
      <div className="immotech-mobile-content">
        {/* Logo */}
        <img 
          src="/2025/immotech/icons/logo.svg" 
          alt="Immotech" 
          className="immotech-mobile-logo"
        />

        {/* Subtitle */}
        <p className="immotech-mobile-subtitle">
          Софтуерът за управление на имот, домакинство и етажна собственост
        </p>

        {/* Collage */}
        <div className="immotech-mobile-collage">
          <img 
            src="/2025/immotech/images/collageTest.png" 
            alt="Immotech conferences and events"
            loading="lazy"
          />
        </div>

        {/* Description */}
        <p className="immotech-mobile-description">
          Изградихме солидна база от доволни потребители в Германия за изминалата година. Подготвихме основата за масова популяризация и засилено разпространение в основните за Имотех пазари. 2026-та година ще бъде интересна и успешна - обещаваме!
        </p>
      </div>
    </section>
  );
};

export default ImmotechMobile;
